<template>
  <div class="manage-index">
    <el-row>
      <el-col :span="4">
        <SidebarHeader>
          <slot>
            <el-menu-item index="/manage/build">
              <span slot="title">结构管理</span>
            </el-menu-item>
            <el-menu-item index="/manage/user">
              <span slot="title">用户管理</span>
            </el-menu-item>
            <el-menu-item index="/manage/device">
              <span slot="title">设备管理</span>
            </el-menu-item>
            <el-menu-item index="/manage/alarm">
              <span slot="title">告警管理</span>
            </el-menu-item>
            <el-menu-item index="/manage/electricQuantity">
              <span slot="title">电量管理</span>
            </el-menu-item>
            <el-menu-item index="/manage/scene">
              <span slot="title">场景管理</span>
            </el-menu-item>
            <!--<el-menu-item index="/manage/lora">-->
              <!--<span slot="title">Lora管理</span>-->
            <!--</el-menu-item>-->
          </slot>
        </SidebarHeader>
      </el-col>

      <el-col :span="24" :offset="0">
        <transition name="child-router-transform" mode="out-in">
          <router-view />
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SidebarHeader from "@/components/layout/SidebarHeader";

export default {
  components: {
    SidebarHeader
  },
  data() {
    return {};
  }
};
</script>

<style scoped="scoped"></style>



// WEBPACK FOOTER //
// src/components/manage/index.vue